module.exports = __webpack_public_path__ + "fonts/SF-Pro-Display-Bold.4e99e4e1.ttf";